namespace Gamification.Gamification {
    export namespace ProdottiAssetEsperienzeService {
        export const baseUrl = 'Gamification/ProdottiAssetEsperienze';

        export declare function Create(request: Serenity.SaveRequest<ProdottiAssetEsperienzeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProdottiAssetEsperienzeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProdottiAssetEsperienzeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProdottiAssetEsperienzeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/ProdottiAssetEsperienze/Create",
            Update = "Gamification/ProdottiAssetEsperienze/Update",
            Delete = "Gamification/ProdottiAssetEsperienze/Delete",
            Retrieve = "Gamification/ProdottiAssetEsperienze/Retrieve",
            List = "Gamification/ProdottiAssetEsperienze/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ProdottiAssetEsperienzeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
